import { localTime, timeText } from "./local-time";
import { svgCreactivitatAnimated } from "../components/svg-creactivitat";

const createMainLogo = () => {
	const wrapper = document.createElement("div");
	wrapper.classList.add("main-logo-wrapper");
	const wrapSVG = document.createElement("div");
	wrapSVG.classList.add("wrap-svg");
	wrapSVG.innerHTML = svgCreactivitatAnimated;
	const ML = document.querySelector(".inicio__main-logo");
	wrapper.appendChild(wrapSVG);
	ML.appendChild(wrapper);
};

const createGreeting = (body) => {
	const tText = timeText(body);
	const wrapper = document.createElement("div");
	wrapper.classList.add("main-logo-wrapper");
	const wrapText = document.createElement("div");
	wrapText.classList.add("wrap-text");
	const saludo = document.createTextNode(tText.toUpperCase());
	const texto = document.createElement("p");
	texto.appendChild(saludo);
	wrapText.appendChild(texto);
	const INI = document.querySelector(".seccion-inicial");
	wrapper.appendChild(wrapText);
	INI.prepend(wrapText);
};

const mainLogo = (body) => {
	localTime(body);
	createGreeting(body);
	createMainLogo();
};

const showMainLogo = (timeLap) => {
	const ML = document.querySelector(".inicio__main-logo");
	if (ML) {
		setTimeout(() => {
			ML.classList.add("show");
			hideGreeting(timeLap);
		}, timeLap);
	}
};

const showGreeting = () => {
	const WT = document.querySelector(".wrap-text");
	if (WT) {
		setTimeout(() => {
			WT.classList.add("show");
		}, 500)
	}
}
const hideGreeting = (timeLap) => {
	const WT = document.querySelector(".wrap-text");
	if (WT) {
		setTimeout(() => {
			WT.classList.add("hide");
		}, timeLap);
	}
};

export { mainLogo, showMainLogo, showGreeting };
